export function createApiHandler(apiClient, path) {
  return {
    async getAll() {
      try {
        const response = await apiClient.get(`${path}`);
        return response.data;
      } catch (error) {
        throw error;
      }
    },

    async getAllWithQueryParams(params) {
      try {
        const queryParams = new URLSearchParams();
        params.forEach(param => {
          if (param.name && param.value) {
            queryParams.append(param.name, param.value);
          }
        });
    
        const response = await apiClient.get(`${path}?${queryParams.toString()}`);
        return response.data;
      } catch (error) {
        throw error;
      }
    },

    async getById(id) {
      try {
        const response = await apiClient.get(`${path}/${id}`);
        return response.data;
      } catch (error) {
        throw error;
      }
    },

    async create(form) {
      try {
        const response = await apiClient.post(`${path}`, form);
        return response.data;
      } catch (error) {
        throw error;
      }
    },

    async update(id, form) {
      try {
        const response = await apiClient.put(`${path}/${id}`, form);
        return response.data;
      } catch (error) {
        throw error;
      }
    },

    async delete(id) {
      try {
        const response = await apiClient.delete(`${path}/${id}`);
        return response.data;
      } catch (error) {
        throw error;
      }
    }
  };
}